<script>
export default {
  props: {
    fill: {
      type: String,
      default: '#000000'
    },
  }
}
</script>

<template>
  <div>
    <svg :fill="fill" height="100%" width="100%" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve">
      <g>
        <g>
          <circle cx="116.364" cy="58.182" r="11.636" />
        </g>
      </g>
      <g>
        <g>
          <path d="M267.636,34.909h-23.273c-19.782,0-34.909,15.127-34.909,34.909v34.909c0,25.6,20.945,46.545,46.545,46.545
			c25.6,0,46.545-20.945,46.545-46.545V69.818C302.545,50.036,287.418,34.909,267.636,34.909z M279.273,104.727
			C279.273,117.527,268.8,128,256,128s-23.273-10.473-23.273-23.273V69.818c0-6.982,4.655-11.636,11.636-11.636h23.273
			c6.982,0,11.636,4.655,11.636,11.636V104.727z" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M290.909,174.545h-69.818c-32.582,0-58.182,25.6-58.182,58.182c0,6.982,4.655,11.636,11.636,11.636
			s11.636-4.655,11.636-11.636c0-19.782,15.127-34.909,34.909-34.909h69.818c19.782,0,34.909,15.127,34.909,34.909
			c0,6.982,4.655,11.636,11.636,11.636c6.982,0,11.636-4.655,11.636-11.636C349.091,200.145,323.491,174.545,290.909,174.545z" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M442.182,0H69.818c-6.982,0-11.636,4.655-11.636,11.636v256c0,6.982,4.655,11.636,11.636,11.636h372.364
			c6.982,0,11.636-4.655,11.636-11.636v-256C453.818,4.655,449.164,0,442.182,0z M430.545,256H81.455V23.273h349.091V256z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M267.636,302.545h-23.273c-19.782,0-34.909,15.127-34.909,34.909v34.909c0,25.6,20.945,46.545,46.545,46.545
			c25.6,0,46.545-20.945,46.545-46.545v-34.909C302.545,317.673,287.418,302.545,267.636,302.545z M279.273,372.364
			c0,12.8-10.473,23.273-23.273,23.273s-23.273-10.473-23.273-23.273v-34.909c0-6.982,4.655-11.636,11.636-11.636h23.273
			c6.982,0,11.636,4.655,11.636,11.636V372.364z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M279.273,442.182h-46.545c-32.582,0-58.182,25.6-58.182,58.182c0,6.982,4.655,11.636,11.636,11.636h93.091
			c6.982,0,11.636-4.655,11.636-11.636s-4.655-11.636-11.636-11.636h-79.127c4.655-13.964,17.455-23.273,32.582-23.273h46.545
			c19.782,0,34.909,15.127,34.909,34.909c0,6.982,4.655,11.636,11.636,11.636s11.636-4.655,11.636-11.636
			C337.455,467.782,311.855,442.182,279.273,442.182z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M442.182,302.545h-23.273c-19.782,0-34.909,15.127-34.909,34.909v34.909c0,25.6,20.945,46.545,46.545,46.545
			c25.6,0,46.545-20.945,46.545-46.545v-34.909C477.091,317.673,461.964,302.545,442.182,302.545z M453.818,372.364
			c0,12.8-10.473,23.273-23.273,23.273s-23.273-10.473-23.273-23.273v-34.909c0-6.982,4.655-11.636,11.636-11.636h23.273
			c6.982,0,11.636,4.655,11.636,11.636V372.364z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M453.818,442.182h-46.545c-32.582,0-58.182,25.6-58.182,58.182c0,6.982,4.655,11.636,11.636,11.636h93.091
			c6.982,0,11.636-4.655,11.636-11.636s-4.655-11.636-11.636-11.636h-79.127c4.655-13.964,17.455-23.273,32.582-23.273h46.545
			c19.782,0,34.909,15.127,34.909,34.909c0,6.982,4.655,11.636,11.636,11.636S512,507.345,512,500.364
			C512,467.782,486.4,442.182,453.818,442.182z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M104.727,302.545H81.455c-19.782,0-34.909,15.127-34.909,34.909v34.909c0,25.6,20.945,46.545,46.545,46.545
			c25.6,0,46.545-20.945,46.545-46.545v-34.909C139.636,317.673,124.509,302.545,104.727,302.545z M116.364,372.364
			c0,12.8-10.473,23.273-23.273,23.273c-12.8,0-23.273-10.473-23.273-23.273v-34.909c0-6.982,4.655-11.636,11.636-11.636h23.273
			c6.982,0,11.636,4.655,11.636,11.636V372.364z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M104.727,442.182H58.182C25.6,442.182,0,467.782,0,500.364C0,507.345,4.655,512,11.636,512h93.091
			c6.982,0,11.636-4.655,11.636-11.636s-4.655-11.636-11.636-11.636H25.6c4.655-13.964,17.455-23.273,32.582-23.273h46.545
			c19.782,0,34.909,15.127,34.909,34.909c0,6.982,4.655,11.636,11.636,11.636c6.982,0,11.636-4.655,11.636-11.636
			C162.909,467.782,137.309,442.182,104.727,442.182z" />
        </g>
      </g>
    </svg>
  </div>
</template>
